import { render, staticRenderFns } from "./AgreementDetail.vue?vue&type=template&id=56615725"
import script from "./AgreementDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreementDetail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports